import React from 'react';
import { Layout, Seo } from '@layout';
import { FaqList } from '@components/FaqList';
import { BlogCarousel } from '@components/BlogCarousel';
import {
  ShopRegistrySection,
  ShopSection,
  RegistrySection,
  RegistryCashFreeGiftingSection,
  RegistryHoneymoonFundSection,
  LinkedRegistrySection,
  RegistryAppSection,
  RegistryJoyButtonSection,
  RegistryBrandsSection,
  ThankYouNotes,
  CharityRegistry,
  OneRegistrySection,
  RegistryCross,
  HeroSectionV0,
} from '@sections/registry';
import { registryPageData } from '@data-ts/pages/registry';
import { faqQuestionsData } from '@data-ts/components/FaqQuestions';
import { CenteredFaqSection } from '@sections/shared/CenteredFaqSection';
import { EasyForYouSection } from '@sections/shared/EasyForYouSection';
import { AbcSection } from '@sections/shared/AbcSection';
import { RecommendProducts } from '@sections/shared/GridView';
import { RegistryChecklist } from '@sections/registry/RegistryChecklist';

interface RegistryBlogs {
  id: string;
  blogs: {
    link: string;
    title: string;
    excerpt: string;
    mediaLink: string;
  }[];
}

interface BlissRegistryData {
  recommendCatalogHomeSections: {
    sections: {
      paginatedCatalogEntities: {
        edges: RecommendProducts;
      };
    }[];
  };
}

interface RegistryPageData {
  bliss: BlissRegistryData;
  featureBlogs: RegistryBlogs;
}

const RegistryV0 = ({ data, page }: { data: RegistryPageData; page: MarcomPageName }) => {
  const { sections } = registryPageData;
  const { faqList } = sections;

  return (
    <Layout
      transparentHeaderButtonVariant="defaultPrimeWeddingWebsites"
      isTransparentHeader={true}
      headerScrollThresholdVh={35}
      page={page}
    >
      <Seo
        title={registryPageData.seo.title}
        canonicalURL={'https://withjoy.com/registry/'}
        description={registryPageData.seo.content}
        ogImage={'common/meta_share/registry.jpg'}
      />
      <HeroSectionV0 />
      <ShopRegistrySection isControlVersion={true} />
      <ShopSection products={data.bliss.recommendCatalogHomeSections.sections[0].paginatedCatalogEntities.edges} isControlVersion={true} />
      <RegistryChecklist />
      <RegistrySection />
      <RegistryCashFreeGiftingSection />
      <RegistryHoneymoonFundSection />
      <LinkedRegistrySection />
      <RegistryAppSection />
      <RegistryJoyButtonSection />
      <RegistryBrandsSection />
      <ThankYouNotes />
      <CharityRegistry />
      <OneRegistrySection />
      <EasyForYouSection pageVariant="registry" />
      <RegistryCross />
      <CenteredFaqSection title={faqList.title} titleColor="blue5" backgroundColor="yellow1" sectionId="Registry_FAQ">
        <FaqList accordion={true} questionNodes={[...faqQuestionsData.registry, ...faqQuestionsData.general]} color="purple6" />
      </CenteredFaqSection>
      <BlogCarousel blogs={data.featureBlogs.blogs} sectionId="Registry_Blog" />
      <AbcSection abcSectionId="Registry_ABC_CTA" page={page} />
    </Layout>
  );
};

export default RegistryV0;
